import {
  MATIC_PRODUCT_ID,
  MATIC_SERENE_PRODUCT_ID,
  MATIC_SERENE_VARIANT_ID,
  MATIC_VARIANT_ID,
} from "@/consts/shopify";

// Matic Serene is its own Matic, so it belongs to the family everywhere isMatic
// and the variant/product checks are applied (cart, checkout, order, shipping).
export const MATIC_FAMILY_PRODUCT_IDS = [
  MATIC_PRODUCT_ID,
  MATIC_SERENE_PRODUCT_ID,
];

export const MATIC_FAMILY_VARIANT_IDS = [
  MATIC_VARIANT_ID,
  MATIC_SERENE_VARIANT_ID,
];

export const isMaticFamilyProductId = (productId?: string | null) => {
  return Boolean(productId && MATIC_FAMILY_PRODUCT_IDS.includes(productId));
};

export const isMaticFamilyVariantId = (variantId?: string | null) => {
  return Boolean(variantId && MATIC_FAMILY_VARIANT_IDS.includes(variantId));
};
